"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const utils_1 = require("utils");
const PreQualAccessForm_1 = require("../../../credit_application/forms/PreQualAccessForm");
const wizard_views_1 = require("../../../credit_application/wizard_views");
const useWaterfallEDS_1 = __importDefault(require("./_hooks/useWaterfallEDS"));
const eds_store_1 = require("./_store/eds.store");
const getSlugs_1 = require("./_utils/getSlugs");
const gotoURL_1 = require("./_utils/gotoURL");
const DisabledEDS_1 = __importDefault(require("./DisabledEDS"));
const WaterfallEDS = () => {
    // Vars
    const submitting = false;
    const submitButtonText = 'Submit';
    // Hooks
    const history = (0, react_router_dom_1.useHistory)();
    const { postApplyAfterPrequal, getApplyAfterPrequalArgs } = (0, useWaterfallEDS_1.default)();
    // Store
    const { edsEnabled, edsApplicant, edsOffer, edsPersonalInfo } = (0, eds_store_1.useEDSStore)();
    if (!edsOffer) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "max-width-600 mar-auto text-center", children: (0, jsx_runtime_1.jsxs)(components_1.P, { children: ["Please re-start the application ", (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, getSlugs_1.getIntroSlug)(), children: "here" }), "."] }) }));
    }
    const prequalification = edsOffer;
    const lenderRequestReferenceId = prequalification.lenderRequestReferenceId;
    // Destructure
    const creditApplicationId = edsApplicant?.creditApplication?.applicationId;
    const personalInfo = edsPersonalInfo;
    const { offers, location } = edsOffer;
    if (!offers) {
        eds_store_1.useEDSStore.setState({
            edsResult: {
                isFailed: true,
                lenderReferenceId: lenderRequestReferenceId,
            },
        });
        (0, gotoURL_1.gotoResult)(history);
        return;
    }
    const lenderName = offers ? offers[0].serviceProviderName : '';
    const prequalifiedCreditLimit = offers ? offers[0].amount : 0;
    const lenderProductType = offers ? offers[0].lenderProductType : '';
    const practice = location;
    // Func
    const onSubmit = async (formVals) => {
        const lenderParams = formVals.lender_required_params;
        const application = getApplyAfterPrequalArgs(prequalification.offers[0], prequalification.applicationId);
        const applicationToSubmit = {
            ...application,
            lenderRequiredParams: {
                ...lenderParams,
            },
        };
        // Post
        const resp = await postApplyAfterPrequal({
            postConsumerApplicationsV2CreditApplicationsApplyAfterPrequalification: {
                ...applicationToSubmit,
            },
        });
        // Response
        if (resp) {
            if ('data' in resp) {
                const applicationStatus = resp.data.applicationStatus;
                if (applicationStatus === 'declined') {
                    // set decline data
                    eds_store_1.useEDSStore.setState({
                        edsResult: {
                            isDenied: true,
                        },
                    });
                }
                if (applicationStatus === 'approved') {
                    // set approved data
                    const approvedData = {
                        personalInfo,
                        practice,
                        lenderName,
                        approvedApplication: { ...resp.data },
                    };
                    eds_store_1.useEDSStore.setState({
                        edsResult: {
                            isApproved: true,
                            ...approvedData,
                        },
                    });
                }
                if (applicationStatus !== 'declined' &&
                    applicationStatus !== 'approved') {
                    const pendingDecisionDetails = resp.data.pendingDecisionDetails;
                    if (pendingDecisionDetails &&
                        pendingDecisionDetails.url &&
                        pendingDecisionDetails.url !== '#') {
                        eds_store_1.useEDSStore.setState({
                            edsResult: {
                                isPending: true,
                                pendingDecisionDetails,
                                personalInfo,
                                prequalification,
                            },
                        });
                        /*
                      <PendHandler
                        iframeUrl={pendingDecisionDetails.url}
                        personalInfo={personalInfo}
                        prequalification={prequalification}
                      />
                      */
                    }
                    else {
                        eds_store_1.useEDSStore.setState({
                            edsResult: {
                                isFailed: true,
                                lenderReferenceId: lenderRequestReferenceId,
                            },
                        });
                        // <FailedMessage lenderReferenceId={lenderReferenceId} />
                    }
                }
                (0, gotoURL_1.gotoResult)(history);
            }
        }
    };
    // Success
    const onSubmitSuccess = () => { };
    // Fail
    const onSubmitFail = () => { };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "container max-width-800 min-height-600 mar-auto", children: [personalInfo && prequalification && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(wizard_views_1.PreQualificationSubprime, { prequalifiedLoanAmount: (0, utils_1.formatCurrency)(prequalifiedCreditLimit, 2), practice: practice, lenderName: lenderName, lenderProductType: lenderProductType }), (0, jsx_runtime_1.jsx)(PreQualAccessForm_1.PreQualAccessForm, { submitFunc: onSubmit, isSubmitting: submitting, onSubmitSuccess: onSubmitSuccess, onSubmitFail: onSubmitFail, submitButtonText: submitButtonText, lenderName: lenderName, locationId: practice.locationId, personalInfo: personalInfo, prequalification: prequalification })] })), (edsEnabled === null || !creditApplicationId) && ((0, jsx_runtime_1.jsx)("div", { className: "container max-width-600 min-height-600 mar-auto text-center", children: (0, jsx_runtime_1.jsxs)(components_1.P, { children: ["Please re-start the application", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, getSlugs_1.getIntroSlug)(), children: "here" }), "."] }) })), edsEnabled === false && (0, jsx_runtime_1.jsx)(DisabledEDS_1.default, {})] }));
};
exports.default = WaterfallEDS;
